import { render, staticRenderFns } from "./ViewFeedback.vue?vue&type=template&id=1e240fd0&"
import script from "./ViewFeedback.vue?vue&type=script&lang=ts&"
export * from "./ViewFeedback.vue?vue&type=script&lang=ts&"
import style0 from "./ViewFeedback.vue?vue&type=style&index=0&id=1e240fd0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports